module.exports = __webpack_public_path__ + "static/media/bohar.841bd447.webp";